<div class="spinner"
     [style.width.rem]="diameter"
     [style.height.rem]="diameter"
     [style.top]="'calc(50% - ' + (diameter / 2) + 'rem)'"
     [style.left]="'calc(50% - ' + (diameter / 2) + 'rem)'">
  <od-svg-spinner animate.enter="od-fade-enter"></od-svg-spinner>
</div>
